import { IntlState } from "react-intl-redux";
import { parsePhoneNumber } from "awesome-phonenumber";
import { filterOutNonDigits } from "checkout/ts/components/flows/card/utils/phoneNumber";
import { PhoneNumber } from "univapay-node";

export const getIntlMessage = (id: string, intl: IntlState) => intl.messages[id];

export const concatPhoneNumber = (phoneNumber: PhoneNumber): string =>
    `${phoneNumber?.countryCode ? `+${phoneNumber.countryCode} ` : ""}${
        filterOutNonDigits(phoneNumber?.localNumber) || ""
    }`;

export const parsePhone = (phoneNumber: string, phoneNumberCountryCode?: string): PhoneNumber => {
    if (!phoneNumber) {
        return null;
    }

    const parsed = parsePhoneNumber(phoneNumber, { regionCode: "JP" });

    return parsed
        ? {
              countryCode: phoneNumberCountryCode || (parsed.countryCode ? `${parsed.countryCode}` : "81"),
              localNumber: parsed.number.input,
          }
        : { countryCode: "", localNumber: "" };
};
